export const SET_LOYALTY = 'SET_LOYALTY';
export const CREATE_LOYALTY = 'CREATE_LOYALTY';
export const EDIT_LOYALTY = 'EDIT_LOYALTY';
export const RESET_LOYALTY = 'RESET_LOYALTY';
export const REACTIVATE_LOYALTY = 'REACTIVATE_LOYALTY';
export const DEACTIVATE_LOYALTY = 'DEACTIVATE_LOYALTY';
export const INIT_LOYALTY_DATA = 'INIT_LOYALTY_DATA';
export const LOAD_UNION_CATEGORIES_AND_ITEMS =
  'LOAD_UNION_CATEGORIES_AND_ITEMS';
export const LOAD_UNION_ITEM_VARIANTS = 'LOAD_UNION_ITEM_VARIANTS';
export const SET_UNION_CATEGORIES = 'SET_UNION_CATEGORIES';
export const SET_UNION_ITEMS = 'SET_UNION_ITEMS';
export const SET_UNION_ITEM_VARIANTS = 'SET_UNION_ITEM_VARIANTS';
